module.exports = __webpack_public_path__ + "86740666c0b494be60f633ad8de8cd7b.svg";